import {createContext} from 'react'

const RecepcionGenericaProductosContext = createContext()

export default RecepcionGenericaProductosContext